import { useContacts, useLoadContacts } from '@entities/contacts/index';
import { memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContactsList } from '@widgets/contacts/index';
import type { EditorType } from '@widgets/shared/Forms/EditorTypes.ts';
import { doCheckArray } from '@shared/helpers/index.ts';
import { FormFieldWithLabelAndPlusBtn } from '@shared/ui/forms/FieldWithLabel/index';

type PT = EditorType<number[], number[]> & { label?: string };

export const FormContactsEditor = memo(({ label, onRedirect, initData, onChange }: PT) => {
  useLoadContacts();
  const navigate = useNavigate();
  const { selectedContacts, setSelectedContacts } = useContacts();

  useEffect(() => {
    doCheckArray(initData) &&
      !doCheckArray(selectedContacts) &&
      setSelectedContacts(initData || []);
  }, [initData]);

  useEffect(() => {
    selectedContacts && onChange?.(selectedContacts);
  }, [selectedContacts]);

  const handleAddContacts = () => {
    onRedirect && onRedirect();
    navigate('/contacts');
  };

  return (
    <FormFieldWithLabelAndPlusBtn
      label={label || 'Контакты'}
      onBtnClick={handleAddContacts}
      withBigButton={!selectedContacts?.length}
    >
      <ContactsList isSelectedList={false} />
    </FormFieldWithLabelAndPlusBtn>
  );
});
